import React from 'react';

import { ICON_MAP } from '../constants';

export const ListTypeIconComponent = (props) => {
  const Icon = ICON_MAP[props.type] || ICON_MAP.default;

  return <Icon style={{ ...props.style }} size={24} />;
};
